<div
  colspan="5"
  class="py-0 block text-center white-space-nowrap w-full text-sm"
>
  <button
    pButton
    pRipple
    type="button"
    label="{{ 'Shared.CREATE-PROSPECT.CREATE_PROSPECT' | translate }}"
    icon="fa fa-plus"
    (click)="OpenPopup()"
    class="p-button-outlined text-sm surface-0"
  ></button>
  <br /><br /><br />
  <img
    width="300"
    src="/assets/img/empty-state-datagrid-img.svg"
    alt="{{ 'Shared.CREATE-PROSPECT.NO_RESULT' | translate }}"
  />
</div>

<!-- <create-prospect
  *ngIf="showCreateProspectPopup | async as showPopup"
  [visible]="showPopup"
  (hidePopup)="hidePopup($event)"
></create-prospect> -->
